import { useI18n } from '@cascade/react/i18n';
import { TagForm } from '#components/tag-form/index.ts';
import { Layout } from '#layout/index.ts';

export const RequiredTags = () => {
  const { translate } = useI18n();

  return (
    <Layout
      mode='card'
      title={translate('tags.required.title')}
      subtitle={translate('tags.required.subtitle')}
    >
      <TagForm />
    </Layout>
  );
};
